/*!
 *  2017-10-20 17:13:38
 *  Copyright 2017 FT, DK Techin Corp 
 */
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _jquery = __webpack_require__(2);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _const = __webpack_require__(1);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	/* eslint-disable */
	C.poiColl = C.poiColl || {};
	var poi_data = C.poiColl.data || C.poiColl || {};
	
	var PoiColl = {
	  collElem: (0, _jquery2['default'])("#poiColl"),
	  mapData: [],
	  map: null,
	  markers: [],
	  infoWindows: [],
	  init: function init() {
	    var _this = this;
	
	    poi_data.map.markers.forEach(function (marker) {
	      return _this.addMapData(marker);
	    });
	    this.bindEvents();
	  },
	  bindEvents: function bindEvents() {
	    var _this2 = this;
	
	    // map controls event.
	    var $mapControls = this.collElem.find('.tool_map');
	    var $mapArea = this.collElem.find('#poiCollMapArea');
	
	    $mapControls.find('.btn_enlarge').on('click', function (e) {
	      return _this2.zoomIn();
	    });
	    $mapControls.find('.btn_reduce').on('click', function (e) {
	      return _this2.zoomOut();
	    });
	    // list type ui event
	    var $placeList = this.collElem.find('.wrap_place');
	    $placeList.on('click', '.link_more', this.onToggleAddressLayer($placeList));
	
	    // toggle biz
	    $placeList.filter(function (i, elem) {
	      return (0, _jquery2['default'])(elem).hasClass('wrap_ad');
	    }).find('.expender').on('click', this.onToggleExpand($placeList.find('.biz_others')));
	
	    // move marker entering mouse over li elements.
	    $placeList.not('.wrap_ad').find('li').on('mouseenter', function (e) {
	      return _this2.onPoiMouseEnter(e);
	    });
	
	    // yellow biz info layer
	    $placeList.find('.link_kakao').on('click', function () {
	      (0, _jquery2['default'])(this).siblings('.layer_kakao').toggleClass('hide');
	    });
	
	    $placeList.find('.layer_kakao .btn_close').on('click', function (e) {
	      (0, _jquery2['default'])(this).parent('.layer_kakao').addClass('hide');
	    });
	
	    // close info window
	    $mapArea.on('click', '.btn_close', function (e) {
	      return _this2.closeInfoWindow("pickInfoWnd");
	    });
	
	    // ad info layer
	    var $infoAddContext = this.collElem.find('.info_adsch');
	    var $infoAddLayer = $infoAddContext.find('#poiAdGuide');
	    $infoAddContext.find('.ico_info').on('click', function () {
	      $infoAddLayer.toggleClass('hide');
	    });
	    $infoAddContext.find('.btn_close').on('click', function () {
	      $infoAddLayer.addClass('hide');
	    });
	
	    // same name region selector
	    this.collElem.find('#poi_regions').on('change', this.changeOtherRegion);
	
	    // view more poi
	    var $btnExpand = this.collElem.find('.poi_extend');
	    if ($btnExpand.length > 0) {
	      var page = _const.EXPAND.START_OF_PAGE;
	      this.initExpander($placeList.not('.wrap_ad').find('ul'), $btnExpand, function (response) {
	        var _C$poiColl = C.poiColl,
	            wx = _C$poiColl.wx,
	            wy = _C$poiColl.wy,
	            lcode = _C$poiColl.lcode,
	            isRealPos = _C$poiColl.meta.isRealPos;
	
	        var qsPrams = _jquery2['default'].extend({
	          coll: 'poi',
	          m: C.poiColl.DA.poi,
	          p: page,
	          offset: C.poiColl.meta.offset,
	          n: _const.EXPAND.COUNT_PER_PAGE,
	          type: 'list',
	          viewsite: viewsite
	        }, isRealPos ? {
	          wx: wx,
	          wy: wy,
	          lcode: lcode
	        } : {});
	
	        _jquery2['default'].ajax({
	          url: SF.getQsUrl(qsPrams, 2),
	          dataType: 'html'
	        }).done(function (html, textStatus) {
	          if (textStatus === 'success') {
	            var $htmlWrapper = (0, _jquery2['default'])('<div></div>').append(html);
	            response($htmlWrapper.find('li'), function ($html) {
	              return $html.find('.' + _const.EXPAND.FLAG_IS_END).length > 0 || page === _const.EXPAND.END_OF_PAGE;
	            }($htmlWrapper));
	            page += 1;
	          } else {
	            response(null);
	            throw new Error(textStatus);
	          }
	        }).fail(function (jqXHR, textStatus) {
	          response(null);
	          throw new Error(textStatus);
	        });
	      });
	    }
	  },
	  initExpander: function initExpander($container, $button, callback) {
	    var _this3 = this;
	
	    // expand log
	    $button.find('.expender').on('click', function (e) {
	      var $elem = (0, _jquery2['default'])(e.currentTarget);
	      $elem.hasClass('open') ? smartLog(e.currentTarget, _this3.makeExpandLogStr($container, 90), e) : smartLog(e.currentTarget, _this3.makeExpandLogStr($container, 91), e);
	    });
	
	    // load expand list
	    new SF.extend({
	      expender: $button,
	      container: $container,
	      viewCount: _const.EXPAND.COUNT_PER_PAGE,
	      source: callback
	    });
	  },
	  makeExpandLogStr: function makeExpandLogStr($container, e) {
	    return 'a=LOTO&dc=' + C.poiColl.DA.poi + '&pg=' + parseInt($container.find('li').length / _const.EXPAND.COUNT_PER_PAGE, 10) + '&s=TO&rc=' + $container.find('li').length + '&ext=' + C.poiColl.meta.extfreeLog + '&e=' + e + '&at=func';
	  },
	  onPoiMouseEnter: function onPoiMouseEnter(e) {
	    this.moveMarker((0, _jquery2['default'])(e.currentTarget).index());
	  },
	  onToggleAddressLayer: function onToggleAddressLayer($placeList) {
	    return function (e) {
	      var $addrLayer = $placeList.find('.layer_more');
	      var $btnToggleAddrLayer = $placeList.find('.link_more');
	      var index = $btnToggleAddrLayer.index(this);
	      $addrLayer.eq(index).toggleClass('hide').toggleClass('open_layer');
	      $addrLayer.filter(function (i, elem) {
	        return i !== index && (0, _jquery2['default'])(elem).hasClass('open_layer');
	      }).removeClass('open_layer').addClass('hide');
	    };
	  },
	  onToggleExpand: function onToggleExpand($items) {
	    return function (e) {
	      (0, _jquery2['default'])(this).toggleClass('open').toggleClass('close');
	      $items.toggleClass('hide');
	    };
	  },
	  zoom: function zoom(level) {
	    var MAX = 15;
	    var MIN = 1;
	    if (level < MAX && level > MIN) this.map.setLevel(level);
	  },
	  zoomIn: function zoomIn() {
	    this.zoom(this.map.getLevel() - 1);
	  },
	  zoomOut: function zoomOut() {
	    this.zoom(this.map.getLevel() + 1);
	  },
	  addMapData: function addMapData(obj) {
	    obj.position = new daum.maps.Coords(obj.wx, obj.wy);
	    this.mapData.push(obj);
	  },
	
	  render: function render(center) {
	    var map = this.makeMap(center),
	        self = this;
	    var bounds = new daum.maps.CoordsBounds();
	
	    // 마커 생성
	    _jquery2['default'].each(this.mapData, function (i, data) {
	      var marker = self.makeMarker(data);
	      self.markers.push(marker);
	    });
	
	    // 데이터 역순으로 마커와 라인을 지도에 그림.첫번째마커를 지도 가장 위에 올리기 위해서 마지막에 생성함
	    for (var idx = this.markers.length - 1; idx >= 0; idx--) {
	      var marker = this.markers[idx];
	      this.markers.length > 1 && bounds.extend(marker.getPosition());
	      marker.setMap(map);
	      marker.line = self.renderLine(idx, marker, bounds);
	      self.bindMarkerEvent(marker, idx);
	    }
	
	    bounds.isEmpty() || map.setBounds(bounds);
	    this.map = map;
	  },
	
	  bindMarkerEvent: function bindMarkerEvent(marker, idx) {
	    var self = this,
	        data = self.mapData[idx];
	    daum.maps.event.addListener(marker, 'click', function () {
	      if (data.marker_type === "exact") {
	        self.clickLogP(data, 65, "func");
	        window.open('http://place.map.daum.net/' + self.mapData[idx].docid).focus();
	        return;
	      }
	      self.panTo(marker);
	      self.closeInfoWindow("mouseoverInfoWnd");
	      self.closeInfoWindow("pickInfoWnd");
	      self.renderInfoWindow(idx, "pickInfoWnd");
	      marker.setZIndex(10);
	      self.clickLogP(data, 65, "func");
	    });
	    daum.maps.event.addListener(marker, 'mouseover', function () {
	      self.renderInfoWindow(idx, "mouseoverInfoWnd");
	      self.activateLine(marker);
	      marker.setZIndex(10);
	    });
	    daum.maps.event.addListener(marker, 'mouseout', function () {
	      self.closeInfoWindow("mouseoverInfoWnd");
	      self.deactivateLine(marker);
	      marker.setZIndex(3);
	    });
	
	    (0, _jquery2['default'])('#poiOpenTimeBtn').click(function () {
	      (0, _jquery2['default'])('#poiOpenTable').toggleClass('hide');
	    });
	
	    (0, _jquery2['default'])('#poiMenuBtn').click(function () {
	      self.collElem.find('.layer_menu').toggleClass('hide');
	    });
	  },
	
	  makeMarker: function makeMarker(d) {
	    return new daum.maps.Marker({
	      position: d.position,
	      image: this.getMarkerImageUrl(d),
	      zIndex: 3
	    });
	  },
	
	  getMarkerImageUrl: function getMarkerImageUrl(d) {
	    var _MARKER_TYPE$d$marker = _const.MARKER_TYPE[d.marker_type],
	        src = _MARKER_TYPE$d$marker.src,
	        w = _MARKER_TYPE$d$marker.w,
	        h = _MARKER_TYPE$d$marker.h,
	        x = _MARKER_TYPE$d$marker.x,
	        y = _MARKER_TYPE$d$marker.y;
	
	
	    return new daum.maps.MarkerImage(src.replace("#", (parseInt(d.idx, 10) + 1).toString()), new daum.maps.Size(w, h), new daum.maps.Point(x, y));
	  },
	
	  renderInfoWindow: function renderInfoWindow(idx, templateId) {
	    var data = this.mapData[idx];
	    var self = this;
	
	    var tmpl = SF.M.tmpl(templateId, {
	      poi: {
	        placeName: data.title,
	        address: data.addr,
	        url: "http://place.map.daum.net/" + data.docid,
	        titleBtnClickLog: this.makeClickLogString(data, 74, "link"),
	        closeBtnClickLog: this.makeClickLogString(data, 88, "func")
	      }
	    });
	
	    var infoWnd = new SF.M.customInfoWindow(this.map, data.position, tmpl, function (node, point) {
	      self.modifyPositionInfoWindow(node, point, _const.MARKER_TYPE[data.marker_type]);
	    }, this);
	    infoWnd.setMap(this.map);
	    infoWnd.templateId = templateId;
	
	    this.infoWindows.push(infoWnd);
	  },
	
	  modifyPositionInfoWindow: function modifyPositionInfoWindow(node, point, markerOpt) {
	    node.style.cssText = 'position: absolute; z-index:999;cursor:default;';
	    var width = node.offsetWidth;
	    var height = node.offsetHeight;
	    node.style.left = point.x - width / 2 + 'px';
	    node.style.top = point.y - (markerOpt.h * 1.2 + height) + 'px';
	  },
	
	  closeInfoWindow: function closeInfoWindow(targetTemplateId, callback) {
	    var self = this;
	    _jquery2['default'].each(self.infoWindows, function (i, v) {
	      if (v.templateId == targetTemplateId) {
	        v.onRemove();
	        self.infoWindows.splice(self.infoWindows.indexOf(v), 1);
	      }
	    });
	  },
	
	  makeMap: function makeMap(center) {
	    if (this.map) {
	      return this.map;
	    }
	    var mapElem = (0, _jquery2['default'])('#poiCollMapArea').get(0);
	    return new daum.maps.Map(mapElem, {
	      center: center ? center : this.getCenter(),
	      scrollwheel: false,
	      level: 4
	    });
	  },
	
	  panTo: function panTo(marker) {
	    //y값 위치보정(지도 height가 낮아서 인포윈도우가 가려짐)
	    var infoWindowOffset = 50;
	    var projection = marker.getProjection();
	    var coords = marker.getPosition();
	    var point = projection.pointFromCoords(coords);
	    point.y -= infoWindowOffset;
	    marker.getMap().panTo(projection.coordsFromPoint(point));
	  },
	
	  getCenter: function getCenter() {
	    return this.mapData[0].position;
	  },
	  changeOtherRegion: function changeOtherRegion() {
	    var $this = (0, _jquery2['default'])(this);
	    location.href = $this.data('url') + $this.find('option:selected')[0].value;
	  },
	
	  renderLine: function renderLine(i, marker, bounds) {
	    if (!this.mapData[i].line_data) {
	      return;
	    }
	    var map = marker.getMap();
	
	    // 라인 정보를 지도 bounds에 포함하여 level결정
	    var lineInfo = this.parseLineInfo(i);
	    this.putLineOnBounds(lineInfo.lineBounds, bounds);
	
	    // 라인의 시작점, 종착점 마커 생성
	    this.makeMarker({
	      idx: -1,
	      position: lineInfo.startPoint,
	      marker_type: "lineDot"
	    }).setMap(map);
	
	    this.makeMarker({
	      idx: -1,
	      position: lineInfo.endPoint,
	      marker_type: "lineDot"
	    }).setMap(map);
	
	    // 장소 마커를 라인 중심으로 이동
	    this.transMarkerOnLine(lineInfo, marker);
	    this.mapData[i].position = lineInfo.center;
	
	    // 지도 그리기
	    return this.makeLine(lineInfo, map);
	  },
	
	  makeLine: function makeLine(li, map) {
	    var line = [];
	    var opt = {
	      strokeColor: '#FE378A',
	      strokeWeight: 3,
	      strokeOpacity: 0.5
	    };
	    for (var i = 0; i < li.positions.length; i++) {
	      line[i] = new daum.maps.Polyline();
	      line[i].setOptions(opt);
	      line[i].setPath(li.positions[i]);
	      line[i].setMap(map);
	    }
	    return line;
	  },
	  transMarkerOnLine: function transMarkerOnLine(lineInfo, marker) {
	    marker.setPosition(lineInfo.center);
	  },
	  putLineOnBounds: function putLineOnBounds(line, bounds) {
	    _jquery2['default'].each(line, function (i, v) {
	      bounds.extend(v);
	    });
	  },
	
	  /**
	   * 장소용 폴리라인을 생성하는 함수
	   * 장소 라인 데이터 - center^start^end^line1@line2@line3^bound@bound
	   * Legacy Code -- 일단 그냥 쓰기
	   * TODO: this.line_position은 어디서 쓰지????
	   * TODO: center, start, end 사용처 확인. 없으면 빼자.
	   */
	  parseLineInfo: function parseLineInfo(data_index) {
	    var data = this.mapData[data_index],
	        line_data = data.line_data;
	
	    var arr_line_data = line_data.split("^");
	    var center = new daum.maps.Coords(arr_line_data[0].split(",")[0], arr_line_data[0].split(",")[1]);
	    var startp = new daum.maps.Coords(arr_line_data[1].split(",")[0], arr_line_data[1].split(",")[1]);
	    var endp = new daum.maps.Coords(arr_line_data[2].split(",")[0], arr_line_data[2].split(",")[1]);
	    var temp_lines = arr_line_data[3].split("@");
	    var bounds = arr_line_data[4].split("@");
	
	    /* line 추출. line은 x,y|x,y 구조 */
	    var line_set = [];
	    for (var j = 0; j < temp_lines.length; j++) {
	      var line_positions = [];
	      var line = temp_lines[j].split("|");
	      if (line.length > 1) {
	        for (var i = 0, g = line; i < g.length; i++) {
	          var temp = g[i].split(",");
	          line_positions.push(new daum.maps.Coords(temp[0], temp[1]));
	        }
	      }
	      line_set.push(line_positions);
	    }
	    /* bound 추출 */
	    var bound_set = [];
	    for (var j = 0; j < bounds.length; j++) {
	      var temp = bounds[j].split(",");
	      if (temp.length == 2) {
	        bound_set.push(new daum.maps.Coords(temp[0], temp[1]));
	      }
	    }
	    return {
	      positions: line_set,
	      center: center,
	      startPoint: startp,
	      endPoint: endp,
	      lineBounds: bound_set
	    };
	  },
	  activateLine: function activateLine(marker) {
	    marker.line && _jquery2['default'].each(marker.line, function (i, v) {
	      return v.setOptions(_const.LINE_TYPE.ACTIVE);
	    });
	  },
	  deactivateLine: function deactivateLine(marker) {
	    marker.line && _jquery2['default'].each(marker.line, function (i, v) {
	      return v.setOptions(_const.LINE_TYPE.DE_ACTIVE);
	    });
	  },
	  moveMarker: function moveMarker(idx) {
	    this.smallerMap13Level() || this.panTo(this.markers[idx]);
	  },
	  smallerMap13Level: function smallerMap13Level() {
	    return this.map.getLevel() < 13;
	  },
	  clickLogP: function clickLogP(data, pVal, actionType) {
	    eval(this.makeClickLogString(data, pVal, actionType));
	  },
	  makeClickLogString: function makeClickLogString(data, pVal, actionType) {
	    var isBizMarker = this.isBizMarkerType(data);
	    var dc = isBizMarker ? poi_data.DA['biz'] : poi_data.DA['poi'];
	    var count = isBizMarker ? poi_data.meta.bizCount : poi_data.meta.poiCount;
	    return this.formatter('smartLog(this, "a=LOTO&pg=1&s=TO&rc=' + count + '&ext=' + poi_data.meta.extfreeLog + '&dc={0}&d={1}&r={2}&at={3}&p={4}", event);', dc, data.docid, parseInt(data.idx, 10) + 1, actionType, pVal);
	  },
	  isBizMarkerType: function isBizMarkerType(data) {
	    return data.marker_type === 'premium' || data.marker_type === 'tilePlus';
	  },
	  formatter: function formatter(format) {
	    var args = Array.prototype.slice.call(arguments, 1);
	    return format.replace(/{(\d+)}/g, function (match, number) {
	      return typeof args[number] !== 'undefined' ? args[number] : match;
	    });
	  }
	};
	daum.maps.load(function () {
	  SF.M.loadCustomMapInfoWindow();
	  PoiColl.init();
	  PoiColl.render();
	  PoiColl.moveMarker(0);
	});

/***/ }),
/* 1 */
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	var MARKER_TYPE = exports.MARKER_TYPE = {
	  exact: {
	    src: '//search1.daumcdn.net/search/statics/common/pi/map/mark_place_bot1_170209.png',
	    w: 39,
	    h: 41,
	    x: 15,
	    y: 44,
	    z_index: 3
	  },
	  normal: {
	    src: '//search1.daumcdn.net/search/statics/common/pi/map/mark_map#_170209.png',
	    w: 30,
	    h: 34,
	    x: 10,
	    y: 34
	  },
	  lineDot: {
	    src: '//search1.daumcdn.net/search/statics/common/pi/map/point_place_bot_170209.png',
	    w: 12,
	    h: 12,
	    x: 10,
	    y: 12
	  },
	  premium: {
	    src: '//search1.daumcdn.net/search/statics/common/pi/map/mark_ad#_170209.png',
	    w: 30,
	    h: 34,
	    x: 10,
	    y: 34
	  },
	  tilePlus: {
	    src: '//search1.daumcdn.net/search/statics/common/pi/map/point_ad_170209.png',
	    w: 10,
	    h: 10,
	    x: 4,
	    y: 3
	  }
	};
	
	var LINE_TYPE = exports.LINE_TYPE = {
	  ACTIVE: {
	    strokeColor: '#D9025C',
	    strokeWeight: 4,
	    strokeOpacity: 0.8
	  },
	  DE_ACTIVE: {
	    strokeColor: '#FE378A',
	    strokeWeight: 3,
	    strokeOpacity: 0.5
	  }
	};
	
	var EXPAND = exports.EXPAND = {
	  COUNT_PER_PAGE: 5,
	  START_OF_PAGE: 1,
	  END_OF_PAGE: 4,
	  FLAG_IS_END: 'end_of_list'
	};

/***/ }),
/* 2 */
/***/ (function(module, exports) {

	module.exports = jQuery;

/***/ })
/******/ ]);


// WEBPACK FOOTER //
// poi/poi.bundle.34232f8.js